import { rangePresets, defaultRangePreset } from '@gogame/intl-ts';
import { object, number, array, string } from '@gogame/schemas';

import {
  FILTER_ADDED,
  FILTER_PERIOD,
  FILTER_ACTIONS_TYPE,
  FILTER_APPLICATIONS,
  FILTER_CREATED_BY,
  FILTER_APPROVERS,
  FILTER_EXPENSE_TYPES,
  FILTER_IMPORTANCE,
  FILTER_STATUSES,
  FILTER_BUSINESS_PARTNERS,
  FILTER_AFFILIATES,
  FILTER_CUSTOMER_COMPANIES,
} from 'scenes/FinancialResults/constants';

export const EMPTY_FILTERS = {
  [FILTER_ADDED]: rangePresets.LIFETIME.value,
  [FILTER_PERIOD]: rangePresets.LIFETIME_PLUS_FUTURE.value,
};

export const filtersSchema = object({
  [FILTER_ADDED]: array(string()).required().constants(defaultRangePreset),
  [FILTER_PERIOD]: array(string()).required().constants(defaultRangePreset),
  [FILTER_APPLICATIONS]: array(number()),
  [FILTER_APPROVERS]: array(number()),
  [FILTER_BUSINESS_PARTNERS]: array(string()),
  [FILTER_AFFILIATES]: array(string()),
  [FILTER_CUSTOMER_COMPANIES]: array(number()),
  [FILTER_CREATED_BY]: array(number()),
  [FILTER_EXPENSE_TYPES]: array(number()),
  [FILTER_IMPORTANCE]: array(number()),
  [FILTER_STATUSES]: array(number()),
  [FILTER_ACTIONS_TYPE]: number(),
}).default({
  [FILTER_ADDED]: rangePresets.THIS_MONTH.value,
  [FILTER_PERIOD]: rangePresets.LIFETIME_PLUS_FUTURE.value,
  [FILTER_ACTIONS_TYPE]: 1,
});
